import * as React from "react"
import { cn } from "@/lib/utils"

/**
 * Simple Container wrapper component for backward compatibility
 * Prefer using <div className="container"> directly
 */
export const Container = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn("w-full", className)}
    {...props}
  />
))
Container.displayName = "Container"
